import React from 'react'

const ApplicationPage = () => {
	return (
		<div>
			Application Forms
		</div>
	)
}

export default ApplicationPage